import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./componant/HomePage";
import Footer from "./common/Footer";
import CoursesHomepage from "./componant/coursesDetails/CoursesHomepage";
import Header from "./common/Header";
import ApplyAcholarship from "./componant/ApplyAcholarship";
import Offers from "./componant/Offers";
import RepeaterEngg from "./componant/RepeaterEngg";
import RepeaterMedical from "./componant/RepeaterMedical";
import AnthePage from "./componant/AnthePage";

function App() {
  return (
    <>
     {/* <Header/> */}
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/course-details" element={<><RepeaterMedical /><CoursesHomepage /></>} />
        <Route path="/apply-scholarship" element={<><Header/><ApplyAcholarship /></>} />
        <Route path="/offers" element={<><Header/><Offers /></>} />
        <Route path="/repeater-engg" element={<><Header/><RepeaterEngg /></>} />
        <Route path="/repeater-medical" element={<><Header/><RepeaterMedical /></>} />
        <Route path="/anthe" element={<><Header/><AnthePage /></>} />
      </Routes>
    </Router>
    <Footer/>
    </>
  );
}

export default App;
